module.exports = __webpack_public_path__ + "static/17-4f6fc34c34bb24afcbeac503f30a16b6.png";